import DisclosureCard from "components/DisclosureCard";

const CardSx = ({ state }) => {
    return (
        <DisclosureCard
            extra={"w-full p-4 sm:overflow-x-auto"}
            button={() => (
                <div className="relative mb-6 flex items-center justify-between">
                    <div className="flex">
                        <div className="mr-6 text-2xl font-bold text-gray-800 dark:text-white">
                            Riepilogo server
                        </div>
                    </div>
                    <div>
                        <img
                            src="/icon/chevron-down.svg"
                            alt="Riepilogo attivazione"
                            className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                        />
                    </div>
                </div>
            )}
            content={() => (
                <div className="flex flex-wrap">
                    <div className="w-full md:w-1/2">
                        <div className="mb-6">
                            <span className="text-sm font-medium text-gray-600">
                                Codice:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.code || ""}
                            </span>
                        </div>
                        <div className="">
                            <span className="text-sm font-medium text-gray-600">
                                Data attivazione:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.activated_at || ""}
                            </span>
                        </div>

                        <div className="mb-6">
                            <span className="text-sm font-medium text-gray-600">
                                Data scadenza:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.expires_at || ""}
                            </span>
                        </div>

                        <div className="mb-6">
                            <span className="text-sm font-medium text-gray-600">
                                Descrizione:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.description || ""}
                            </span>
                        </div>
                        <div></div>
                    </div>
                    <div className="w-full md:w-1/2">
                        <div className="">
                            <span className="text-sm font-medium text-gray-600">
                                Modello:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.model || ""}
                            </span>
                        </div>
                        <div className="mb-6">
                            <span className="text-sm font-medium text-gray-600">
                                Firmware:{" "}
                            </span>
                            <span className="text-sm font-medium text-gray-800">
                                {state?.firmware || ""}
                            </span>
                        </div>
                        <div className="">
                            <span className="text-sm font-medium text-gray-600">
                                SSL:{" "}
                            </span>
                            <span
                                className={"text-sm font-medium text-gray-800"}
                            >
                                {state?.license?.ssl ? "Sì" : "No"}
                            </span>
                        </div>
                        {state?.license?.ssl ? (
                            <div className="mb-6">
                                <span className="text-sm font-medium text-gray-600">
                                    Scadenza SSL:{" "}
                                </span>
                                <span
                                    className={
                                        "text-sm font-medium text-gray-800"
                                    }
                                >
                                    {state?.ssl_expires_at}
                                </span>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        />
    );
};

export default CardSx;
